document.addEventListener("DOMContentLoaded", function(event) {
  if(document.querySelector('span[data-add-to-cart-text]')){
    function changeButton(){
    let ourBox = '';
    let dataAdd = document.querySelector('span[data-add-to-cart-text]').innerText;
    let mainBox = document.querySelector('.product__addtoprice');
    if(dataAdd == 'SOLD OUT'){
      mainBox.classList.add('disable');
    }else{
      mainBox.classList.remove('disable');
    }
    let price;
    if(!document.querySelector('span[data-sale-price]').style.display == 'none'){
      price= document.querySelector('span[data-sale-price]').innerText;
    }else{
      price = document.querySelector('span[data-regular-price]').innerText;
    }
    let prodId = window.location.href;
    let prodIdValue = prodId.split('=')[1];
    if(prodId.split('=')[1] === undefined){
      prodIdValue = document.querySelector('#ProductSection-product-template').getAttribute('product-id');
    }
    let singleOption = document.querySelector('.single-option-selector');
    if(singleOption){
       singleOption.value;
    }
    document.querySelector('.product__addtoprice').querySelector('input[name="add"]').setAttribute('value',dataAdd.trim() + ' ' + price.trim());
    document.querySelector('.product__addtoprice').querySelector('input[name="id"]').setAttribute('value', prodIdValue);
    }
    changeButton();
    document.addEventListener('change', function(event) {
      changeButton();
    });

    if(document.getElementById("ProductSelect-product-template")){
      let elemAvailable = document.querySelector('.product-template__in-available');
      var e = document.getElementById("ProductSelect-product-template");
      function getOptionQuant(){
        var value = e.value;
        var quant = e.options[e.selectedIndex].getAttribute('quan');
        if(quant > 15){
          elemAvailable.innerText = 'In stock';
        }else if(quant <= 15 && quant > 3){
          elemAvailable.innerText = 'Low stock';
        }else if(quant <= 3 && quant != 0){
          elemAvailable.innerText = 'Last';
        }else if(quant == 0){
          elemAvailable.innerText = 'sold out';
        }
      }    
      getOptionQuant();
      document.addEventListener('change', getOptionQuant);
    };
  }

  const body = document.querySelector('body');
  const stickyHeader = document.querySelector('div[data-section-id="header"]');
  function getHeight(){
    let headerHeight = stickyHeader.offsetHeight;
    body.setAttribute('style','padding-top:'+ headerHeight + 'px');
  }
  getHeight();
  window.addEventListener('resize',getHeight);

  let shadowInter = setInterval(function(){
      if(document.querySelector('afterpay-placement')){
        let kek = document.querySelector('afterpay-placement').shadowRoot;
        kek.querySelector('.afterpay-main-text').setAttribute('style','font-family: Helvetica !important; font-weight: 700 !important;');
        clearInterval(shadowInter);
      };
  },100)

  
});


